import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <div className="topHeader row col-md-12 col-xs-12 p-0 mr-0 ml-0">
      <div className="col-md-6 col-xs-12 ml-0 pl-3">
        <img src="https://blog.mintifi.com/wp-content/uploads/2021/07/logo.png"  alt="logo"  className="mt-3"/>
      </div>
      <div className="col-md-6 col-xs-12 pr-0">
        <div className="d-flex float-right">
          <div className="mt-3">
            <img src='/images/profile.png' className="imgStyle" alt="profile" />
          </div>
          <span className="m-2 mt-4 menuName">name</span>
          <span className="m-2 mt-4"></span>
          <span className="box"><img src='/images/Group 2188.png' alt="notification" /></span>
          <span className="box"><img src='/images/Add-Alarm.png' alt="alarm" /></span>
          <span className="box"><img src='/images/Shut-Down.png' alt="ShutDown" /></span>
        </div>
      </div>
    </div>
  );
};

export default Header;